import { PathMenuItem } from "core/FeaturePathMenus";

export const pathMenus: PathMenuItem[] = [
  {
    url_id: "/list/kelola-nasabah/pemutusan-relasi-bsya-junior",
    url_path: "/list/kelola-nasabah/pemutusan-relasi-bsya-junior",
  },
  {
    url_id: "/list/kelola-nasabah/pemutusan-relasi-bsya-junior",
    url_path: "/form/kelola-nasabah/pemutusan-relasi-bsya-junior",
  },

  {
    url_id: "/list/persetujuan/pemutusan-relasi-bsya-junior",
    url_path: "/list/persetujuan/pemutusan-relasi-bsya-junior",
  },
  {
    url_id: "/list/persetujuan/pemutusan-relasi-bsya-junior",
    url_path: "/form/persetujuan/pemutusan-relasi-bsya-junior",
  },
];
